var _style, _path, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgHouseHalf(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 45 46",
    style: {
      enableBackground: "new 0 0 45 46"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#004282;}\n\t.st1{clip-path:url(#SVGID_00000070819658293369434460000000342799625014703240_);fill:#006BB7;}\n")), /*#__PURE__*/React.createElement("g", null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M44.6,22l-4.3-4.4V4.3c0-0.7-0.5-1.2-1.2-1.2h-6.1c-0.6,0-1.2,0.5-1.2,1.2V9l-8.5-8.6c-0.5-0.5-1.2-0.5-1.7,0 L0.3,22c-0.8,0.8-0.3,2.1,0.8,2.1h4.3v20.7c0,0.7,0.5,1.3,1.2,1.3h31.7c0.6,0,1.2-0.5,1.2-1.3V24.1h4.2 C44.8,24.1,45.3,22.8,44.6,22z M30.5,30.5h-6.5v-6.6h6.5V30.5z M20.8,23.9v6.6h-6.5v-6.6H20.8z M14.4,33.8h6.5v6.6h-6.5V33.8z  M24.1,40.4v-6.6h6.5v6.6H24.1z"
  })), /*#__PURE__*/React.createElement("g", null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "SVGID_1_",
    x: 0,
    y: 0.1,
    width: 25.2,
    height: 46
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000118384642495549849740000010786621744298076041_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_1_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      clipPath: "url(#SVGID_00000118384642495549849740000010786621744298076041_)",
      fill: "#006BB7"
    },
    d: "M44.6,22l-4.3-4.4V4.2 c0-0.7-0.5-1.2-1.2-1.2H33c-0.6,0-1.2,0.5-1.2,1.2V9l-8.5-8.6c-0.5-0.5-1.2-0.5-1.7,0L0.3,22c-0.8,0.8-0.3,2.1,0.8,2.1h4.3v20.7 c0,0.7,0.5,1.3,1.2,1.3h31.7c0.6,0,1.2-0.5,1.2-1.3V24.1h4.2C44.8,24.1,45.3,22.8,44.6,22z M30.5,30.5h-6.5v-6.6h6.5V30.5z  M20.8,23.9v6.6h-6.5v-6.6H20.8z M14.4,33.8h6.5v6.6h-6.5V33.8z M24.1,40.3v-6.6h6.5v6.6H24.1z"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgHouseHalf);
export default __webpack_public_path__ + "static/media/house-half.df6630a8d65e9dd000d8e252facf5e79.svg";
export { ForwardRef as ReactComponent };